import Controller, { OnClose, OnMount, OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { ThemeTonalRange } from '@philips-internal/oswald-ui-constants';
import { HistoryService, ThemeService } from '@philips-internal/oswald-ui-core/lib/services';
import { getFoundationDataContext } from '../../app/bootstrap-foundation';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { AccountCreationModalAliases, FragmentNames, Routes } from '../../codegen';
import UserContext from '../../utils/user-context';

@Controller({ fragment: FragmentNames.ACCOUNT_CREATION_MODAL })
export default class AccountCreationModalController extends BaseController {

  @OnMount(AccountCreationModalAliases.MODAL_ACCOUNT_CREATION)
  changeTheme(): void {

    const { hasAccessToUserRegistration } = UserContext.twsUserParameters;
    if (!hasAccessToUserRegistration) {
      HistoryService.push(Routes.LOGIN);
    }

    setTimeout(() => {
      ThemeService.setContentTonalRange(ThemeTonalRange.ULTRA_LIGHT);
    });
  }

  @OnUnmount({ target: 'modal-account-creation' })
  handleExitModal(): void {
    this.updateTheme();
  }

  @OnClose({ target: 'modal-account-creation' })
  onCloseModalAccountCreation(): void {
    this.updateTheme()
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }

  private updateTheme(): void {
    const { loginContentTonalRange = ThemeTonalRange.BRIGHT } = getFoundationDataContext().getBulkData();
    ThemeService.setContentTonalRange(loginContentTonalRange as ThemeTonalRange);
  }

}